export enum PricingSectionTypesEnum {
  STARTER = 'Starter / Consulting',
  GROWER = 'Grower / Prototype',
  ADVANCED = 'Advanced / Take-off',
}
